import { render, staticRenderFns } from "./ReportChoice.vue?vue&type=template&id=5972f4ae&scoped=true&"
import script from "./ReportChoice.vue?vue&type=script&lang=js&"
export * from "./ReportChoice.vue?vue&type=script&lang=js&"
import style0 from "./ReportChoice.vue?vue&type=style&index=0&id=5972f4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5972f4ae",
  null
  
)

export default component.exports